module.exports = __webpack_public_path__ + "static/p3-42b06c2f6ddad941d40bbf5dd5492ef2.jpg";